import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Suspense } from "react";
import AppLoading from "../app-loading/app-loading";

const SummaryTableSalesInDetailsDatatable = ({ data, type }: any) => {

    const invoiceDateBody = (rowData: any) => {
        const dt = new Date(rowData.invoiceDate);
        return dt.toLocaleDateString('en-GB'); // Outputs: 22/07/2025
    };

    const orderDateBody = (rowData: any) => {
        const dt = new Date(rowData.orderDate);
        return dt.toLocaleDateString('en-GB'); // Outputs: 22/07/2025
    };

    return (
        <div className="col-12">
            <Suspense fallback={<AppLoading />}>
                <DataTable
                    value={data}
                    paginator
                    rows={10}
                    rowsPerPageOptions={[5, 10, 20, 50]}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                >
                    <Column header="Order Date" body={orderDateBody} sortable />
                    <Column field="orderId" header="OrderID" sortable />
                    <Column field="quantity" header="Quantity" sortable />
                    <Column field="invoiceNo" header="InvoiceNo" sortable />
                    <Column header="Invoice Date" body={invoiceDateBody} sortable />
                    <Column field="invoiceBy" header="Invoice By" sortable />
                </DataTable>
            </Suspense>
        </div>
    )

}

export default SummaryTableSalesInDetailsDatatable;